<template>
	<div class="content">
		<div class="cont_title">课程管理</div>
		<div class="top">
			<el-input style="width: 280px;margin-right: 30px;" 
			@keyup.enter.native="getList" v-model="queryParams.keywords" placeholder="请输入课程名称查询" type="text"/>
			  <!-- <el-select style="width: 280px;margin-right: 30px;" v-model="queryParams.department_name" placeholder="请选择课程院系">
			      <el-option
			        v-for="item in selist"
			        :key="item.id"
			        :label="item.department_name"
			        :value="item.department_name">
			      </el-option>
			  </el-select> -->
			<el-button icon="el-icon-search" type="primary" @click="getList()">查询</el-button>
			<div class="top_rig">
				<div class="zujuan_btn btn1" @click="addTeacher()">
					<img src="../../assets/img/tea2.png" alt="">
					<div>新增课程</div>
				</div>
				<div class="zujuan_btn btn2" @click="delTeacher()">
					<img src="../../assets/img/tea1.png" alt="">
					<div>批量删除</div>
				</div>
			</div>
		</div>
		<el-table style="width: 100%;margin-top: 30px;" border v-loading="loading"
		 :data="tableData" @selection-change="handleSelectionChange" :header-cell-style="{background: '#F5F6F7'}">
			<el-table-column type="selection" width="55" align="center" />
			<el-table-column label="课程封面" align="center" prop="litpic">
			  <template slot-scope="scope">
			    <image-preview :src="scope.row.litpic" :width="50" :height="50"/>
			  </template>
			</el-table-column>
			<el-table-column prop="kecheng_name" label="课程名称" align="center"/>
			<!-- <el-table-column prop="department_name" label="所属院系" align="center"/> -->
			<el-table-column  label="操作" align="center">
				<template slot-scope="scope">
					<el-button @click="editTeacher(scope.row,2)" type="text" size="small">班级列表</el-button>
					<el-button @click="editTeacher(scope.row,1)" type="text" size="small">编辑</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="block" style="margin-top: 20px;text-align: center;">
			<el-pagination background  @current-change="handleCurrentChange" 
			:current-page="currentPage" layout="prev, pager, next" :total="total"></el-pagination>
		</div>
		 
	</div>
</template>
<script>
import {kecheng_list,bact_delete_kecheng,department_list} from "../../api/new.js";	
	export default {
		data() {
			return {
				loading: true,
				tableData: [],
				queryParams:{
					keywords:'',
					limit:10,
					page:1,
				},
				total: 0,
				currentPage: 1,
				selist:[],
			};
		},
		
		mounted() {
			this.yuanxi()
			this.getList()
		},
		methods: {
			yuanxi(){
				var _this = this
				var data = {limit:1000,page:1}
				//院系列表
				department_list(data).then((res) => {
					if (res.code == 0) {
						this.selist = res.data
					}
				})
			},
			//列表
			getList(){
				var _this = this
				this.loading = true
				kecheng_list(this.queryParams).then((res) => {
					this.loading = false
					if (res.code == 0) {
						this.tableData = res.data
						this.total = res.total
					} else {
						this.$message.error(res.msg);
					} 
				})
				.catch((err) => {
					this.loading = false
				});	
			},
			//删除
			delTeacher(){
				var _this = this
				if(this.ids.length > 0){
					var idd = this.ids.toString()
					var data = { id:idd }
					this.$confirm('您确定要删除吗？', "提示", {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "warning",
						}).then(() => {
							bact_delete_kecheng(data).then((res) => {
								if (res.code == 0) {
									_this.$message.success(res.msg);
									_this.getList()
								} else {
									this.$message.error(res.msg);
								}
							  }).catch((err) => {
									console.log(err);
							  });
						}).catch(() => {});
				}
			},
			addTeacher(){
				this.$router.push({ path: "/addKe" });
			},
			editTeacher(e,act){
				this.$router.push({
				  path: "/addKe",
				  query: {
				    id: e.id,
					act:act
				  },
				});
			},
			// 多选框选中数据
			handleSelectionChange(selection) {
				this.ids = selection.map(item => item.id)
			},
			//上一页，下一页
			handleCurrentChange(currentPage) {
				this.queryParams.page = currentPage;
				this.currentPage = currentPage;
				this.getList()
			}
		},
	};
</script>
<style lang="less" scoped>
div{
	box-sizing: border-box;
}
.content{
	width: 100%;
	min-width: 1200px;
	background: #FFFFFF;
	border-radius: 20px;
	padding: 30px;	
	
	.top{
		width: 100%;
		display: flex;
		align-items: center;
		// justify-content: space-between;
		margin-top: 50px;
		.top_rig{
			display: flex;
			margin-left: auto;
		}
		.zujuan_btn{
			width: 140px;
			height: 44px;
			background: #4076F3;
			border-radius: 10px;
			font-size: 16px;
			color: #FFFFFF;
			line-height: 44px;
			text-align: center;
			cursor: pointer;
			margin-left: 35px;
			display: flex;
			align-items: center;
			justify-content: center;
			img{
				width: 24px;
				height: 24px;
				margin-right: 6px;
			}
		}
		.btn1{
			background: #ED7F26;
		}
		.btn2{
			background: #E13049;
		}
		.zujuan_btn:hover{
			opacity: 0.7;
		}
		.zujuan_btn:active{
			opacity: 0.9;
		}
	}
	
}	
</style>



// WEBPACK FOOTER //
// src/components/kecheng/keList.vue